import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { WarningMessagingComponent } from './warning-messaging.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule
    ],
    declarations: [
        WarningMessagingComponent
    ],
    exports: [
        WarningMessagingComponent
    ]
})
export class WarningMessagingModule { }
